// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"d2c43911","868":"741488a7"}[chunkId] + ".chunk.js";
};